import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import LanguageTab from './LanguageTab';
import settings from "../../../config/settings";
import { changeLanguage } from '../../../store/actionCreators/profileSettings';
import dropdownStyles from "../../../config/customStyles";

const customStyles = dropdownStyles.languageCustomStyles;

const LanguageSelector = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const stateSelectedLanguage = useSelector(state => state.selectedLanguage);
    const activeLanguage = ["en", "ar", "fr", "pt", "it"];

    const defaultLangValue = localStorage.language || stateSelectedLanguage;
    const defaultLangObject = {
        value: defaultLangValue,
        label: t(`language.${defaultLangValue}`)
    };

    const [selectedLanguage, setSelectedLanguage] = useState(defaultLangObject);

    const languages = useMemo(() => settings.languages.map(
        lang => ( { value: lang, label: t(`language.${lang}`) } )
    ), [selectedLanguage]);

    const selectLanguage = lang => {
        if (activeLanguage.includes(lang.value)) {
            setSelectedLanguage(lang);
            dispatch(changeLanguage(lang.value));
        }
    };

    return (
        <div className='langSelector'>
            <Select
                options={languages}
                formatOptionLabel={LanguageTab}
                onChange={selectLanguage}
                defaultValue={selectedLanguage}
                isSearchable={false}
                styles={customStyles}
                value={{ value: selectedLanguage.value, label: t(`language.${selectedLanguage.value}`) }}
            />
        </div>
    );
};

export default LanguageSelector;
